<template>
  <div id="page-user-view">
    <data-view-sidebar-request-videocall :isSidebarActive="addNewDataSidebarRequestVideoCall" @closeSidebar="toggleDataSidebarRequestVideoCall" :data="sidebarDataRequestVideoCall" v-on:closeSidebar="updateVideoCallsCard"/>
    <data-view-sidebar-request-service :isSidebarActive="addNewDataSidebarRequestService" @closeSidebar="toggleDataSidebarRequestService" :data="sidebarDataRequestService" v-on:closeSidebar="updateServicesCard"/>

    
    <!-- <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.client_id }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert> -->

    <div id="user-data">

      <!-- CARD ADDED SERVICES DEL CLIENTE -->
      <!-- <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card title="Análisis financieros agregados a su cuenta" class="mb-base" action-buttons @refresh="refreshCardMyFinancialAnalysis">
            <div id="error_card_comentarios"></div>
            <vs-table :data="myFinancialAnalysis" id="document-table" stripe search>

              <template slot="header">
                <div class="flex flex-wrap-reverse items-center flex-grow justify-between mb-2">
                </div>
              </template>
              <template slot="thead">
                <vs-th sort-key="name_service">Nombre</vs-th>
                <vs-th sort-key="hired_financial_analysis">Análisis contratados</vs-th>
                <vs-th sort-key="accomplished_financial_analysis">Análisis completados</vs-th>
                <vs-th sort-key="available_financial_analysis">Análisis disponibles</vs-th>
                <vs-th sort-key="flag_active_financial_analysis">¿Activo?</vs-th>
                <vs-th sort-key="updated_at_financial_analysis">Última actualización</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>{{ data[indextr].name_service }}</vs-td>
                  <vs-td>{{ data[indextr].hired_financial_analysis | financial_analysys_corrected}}</vs-td>
                  <vs-td>{{ data[indextr].accomplished_financial_analysis }}</vs-td>
                  <vs-td>{{ data[indextr].available_financial_analysis }}</vs-td>
                  <vs-td>{{ data[indextr].flag_active_financial_analysis | showYesNo}}</vs-td>
                  <vs-td>{{ data[indextr].updated_at_financial_analysis | formato_fecha2}}</vs-td>
                  <template class="expand-user ml-2" slot="expand">
                    <div class="con-expand-users w-full">
                      <vs-list>
                        <vs-list-item icon-pack="feather" icon="icon-check" title="Fecha creación del servicio" :subtitle="tr.created_at_financial_analysis | formato_fecha2"></vs-list-item>
                      </vs-list>
                    </div>
                  </template>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div> -->

      <!-- CARD VIDEOLLAMADAS DEL CLIENTE -->
      <!-- <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card title="Videollamadas" class="mb-base" action-buttons @refresh="refreshCardVideoCalls">
            <div id="error_card_comentarios"></div>
            <vs-table :data="videoCalls" id="document-table" stripe search>

              <template slot="header">
                <div class="flex flex-wrap-reverse items-center flex-grow justify-between mb-2">
                <vs-button type="border" icon-pack="feather" icon="icon-plus" @click="addNewDataVideoCallRequest()" v-if="this.name_role !== 'Usuario Registrado'">Solicitar Videollamada</vs-button>
                </div>
              </template>
              <template slot="thead">
                <vs-th sort-key="name_video_call_type">Nombre</vs-th>
                <vs-th sort-key="client_availability_video_call">Disponibilidad anunciada</vs-th>
                <vs-th sort-key="list_of_business_video_call">IDs de Negocios</vs-th>
                <vs-th sort-key="full_name_employee">Asesor responsable</vs-th>
                <vs-th sort-key="status_video_call">Estatus</vs-th>
                <vs-th sort-key="date_and_time_video_call">Fecha Videollamada</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>{{ data[indextr].name_video_call_type }}</vs-td>
                  <vs-td>{{ data[indextr].client_availability_video_call }}</vs-td>
                  <vs-td>{{ data[indextr].list_of_business_video_call }}</vs-td>
                  <vs-td>{{ data[indextr].full_name_employee }}</vs-td>
                  <vs-td>{{ data[indextr].status_video_call }}</vs-td>
                  <vs-td>{{ data[indextr].date_and_time_video_call }}</vs-td>
                  <template class="expand-user ml-2" slot="expand">
                    <div class="con-expand-users w-full">
                      <vs-list>
                        <vs-list-item icon-pack="feather" icon="icon-check" title="Fecha creación de solicitud" :subtitle="tr.created_at_video_call | formato_fecha"></vs-list-item>
                      </vs-list>
                    </div>
                  </template>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div> -->

      <!-- CARD SOLICITUDES DE SERVICIO PLAN -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card title="Solicitar servicio Extranjería" class="mb-base" action-buttons @refresh="refreshCardSolicitudes">
            <div id="error_card_pagos"></div>
            <vs-table :data="myRequests" id="document-table" stripe search>
              <template slot="header">
                <div class="flex flex-wrap-reverse items-center flex-grow justify-between mb-2">
                <vs-button type="border" icon-pack="feather" icon="icon-plus" @click="addNewDataServiceRequest()">Solicitar servicios</vs-button>
                </div>
              </template>
              <template slot="thead">
                <vs-th sort-key="id_client_request">ID</vs-th>
                <vs-th sort-key="name_service">Servicio a contratar</vs-th>
                <vs-th sort-key="flag_attended_client_request">¿Atendido?</vs-th>
                <vs-th sort-key="created_at_client_request">Fecha Solicitud</vs-th>
                <vs-th sort-key="attended_at_client_request">Fecha Atención</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>{{ data[indextr].id_client_request }}</vs-td>
                  <vs-td>{{ data[indextr].name_service }}</vs-td>
                  <vs-td>{{ data[indextr].flag_attended_client_request | showYesNo }}</vs-td>
                  <vs-td>{{ data[indextr].created_at_client_request | formato_fecha }}</vs-td>
                  <vs-td>{{ data[indextr].attended_at_client_request | formato_fecha2 }}</vs-td>
                  <template class="expand-user ml-2" slot="expand">
                    <div class="con-expand-users w-full">
                        <vs-list>
                            <vs-list-item icon-pack="feather" icon="icon-message-circle" title="Nota cuando se hizo solicitud" :subtitle="tr.client_comment_client_request"></vs-list-item>
                        </vs-list>
                    </div>
                  </template>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div>
      

    </div>
  </div>
</template>

<script>
import RequestVideoCallDataViewSidebar from './RequestVideoCallDataViewSidebar.vue'
import RequestServiceDataViewSidebar from './RequestServiceDataViewSidebar.vue'
import vSelect from 'vue-select'


export default {
  components: {
    vSelect,
    DataViewSidebarRequestVideocall: RequestVideoCallDataViewSidebar,
    DataViewSidebarRequestService: RequestServiceDataViewSidebar

  },  
  data () {
    return {
      id_client: null,
      name_role:null,
      // scrollbar
      settings             : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30
      },
      isMounted: false,
      // Data Sidebar VideoCalls
      addNewDataSidebarRequestVideoCall: false,
      sidebarDataRequestVideoCall: {},

      // Data Sidebar Services
      addNewDataSidebarRequestService: false,
      sidebarDataRequestService: {},

      user_not_found: false
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    videoCalls () {
      return this.$store.state.videoCallsPerClient
    },
    myRequests () {
      return this.$store.state.myRequests
    },
    myFinancialAnalysis () {
      return this.$store.state.myFinancialAnalysis
    }
  },
  methods: {

    /////////////////////////////////  MY FINANCIAL ANALYSIS / ADDED SERVICES  /////////////////////
    refreshCardMyFinancialAnalysis (card) {
      this.$store.dispatch('fetchMyFinancialAnalysisForClients')
        .then(() => {
          this.$vs.loading.close()
          card.removeRefreshAnimation(0) 
        })
        .catch(error => {
          console.error(error)
          this.$vs.loading.close()
          card.removeRefreshAnimation(0)
        })
    },

    ///////////////////////////////////       VIDEOCALLS  /////////////////////////////////// 
    refreshCardVideoCalls (card) {
      this.$store.dispatch('fetchVideoCallsPerClient', this.id_client)
        .then(() => {
          this.$vs.loading.close()
          card.removeRefreshAnimation(0) 
        })
        .catch(error => {
          console.error(error)
          this.$vs.loading.close()
          card.removeRefreshAnimation(0)
        })
    },
    updateVideoCallsCard () {
      this.$vs.loading()
      setTimeout(function () { this.refrescarCardVideoCalls() }.bind(this), 0)
    },
    refrescarCardVideoCalls () {
      this.$store.dispatch('fetchVideoCallsPerClient', this.id_client)
        .then(() => { this.$vs.loading.close() })
        .catch(err => {
          console.log(err)
          this.$vs.loading.close()
        })
    }, 
    addNewDataVideoCallRequest () {
      this.sidebarDataRequestVideoCall = {}
      this.toggleDataSidebarRequestVideoCall(true)
    },
    toggleDataSidebarRequestVideoCall (val = false) {
      this.addNewDataSidebarRequestVideoCall = val
    },

    ///////////////////////////////// client-request ////////////////////////////
    refreshCardSolicitudes (card) {
      this.$store.dispatch('fetchMyRequests')
        .then(() => {
          this.$vs.loading.close()
          card.removeRefreshAnimation(0) 
        })
        .catch(error => {
          console.error(error)
          this.$vs.loading.close()
          card.removeRefreshAnimation(0)
        })
    },
    updateServicesCard () {
      this.$vs.loading()
      setTimeout(function () { this.refrescarServicesCard() }.bind(this), 0)
    },
    refrescarServicesCard () {
      this.$store.dispatch('fetchMyRequests')
        .then(() => { this.$vs.loading.close() })
        .catch(err => {
          console.log(err)
          this.$vs.loading.close()
        })
    },
    addNewDataServiceRequest () {
      this.sidebarDataRequestService = {}
      this.$store.dispatch('fetchServices')
      this.toggleDataSidebarRequestService(true)
    },
    toggleDataSidebarRequestService (val = false) {
      this.addNewDataSidebarRequestService = val
    }
  },
  created () {
    this.$store.dispatch('fetchUserData')

    //Carga de SERVICIOS YA AGREGADOS my financial analysys 
    // this.$store.dispatch('fetchMyFinancialAnalysisForClients')
    //   .catch(err => { 
    //     this.$vs.loading.close()
    //     console.error(err)
    //     const mensaje_error = err.response.data.message

    //     if (typeof mensaje_error === 'string') {
    //       this.$vs.notify({
    //         title: 'Error',
    //         text: `${mensaje_error}`,
    //         color: 'warning',
    //         iconPack: 'feather',
    //         icon:'icon-x-circle',
    //         time: 6000
    //       })
    //     } else {
    //       const array_errors = Object.entries(mensaje_error)
    //       for (let i = 0; i < array_errors.length; i++) {
    //         this.$vs.notify({
    //           title: 'Error',
    //           text: `${array_errors[i][1][0]}`,
    //           iconPack: 'feather',
    //           icon: 'icon-x-circle',
    //           color: 'warning',
    //           time: 6000
    //         })
    //       }
    //     }
    //   })

    //Carga de videollamdas del cliente
    // this.$store.dispatch('fetchVideoCallsPerClient', this.id_client)
    //   .catch(err => { 
    //     this.$vs.loading.close()
    //     // console.log(Object.getOwnPropertyNames(err))
    //     console.error(err)
    //     // console.log(err.response.data.errors)
    //     const mensaje_error = err.response.data.message

    //     if (typeof mensaje_error === 'string') {
    //       this.$vs.notify({
    //         title: 'Error',
    //         text: `${mensaje_error}`,
    //         color: 'warning',
    //         iconPack: 'feather',
    //         icon:'icon-x-circle',
    //         time: 6000
    //       })
    //     } else {
    //       const array_errors = Object.entries(mensaje_error)
    //       for (let i = 0; i < array_errors.length; i++) {
    //         this.$vs.notify({
    //           title: 'Error',
    //           text: `${array_errors[i][1][0]}`,
    //           iconPack: 'feather',
    //           icon: 'icon-x-circle',
    //           color: 'warning',
    //           time: 6000
    //         })
    //       }
    //     }
    //   })

    //Carga de videollamdas del cliente
    this.$store.dispatch('fetchMyRequests')
      .catch(err => { 
        this.$vs.loading.close()
        console.error(err)
        const mensaje_error = err.response.data.error
        if (typeof mensaje_error === 'string') {
          this.$vs.notify({
            title: 'Error',
            text: `${mensaje_error}`,
            color: 'warning',
            iconPack: 'feather',
            icon:'icon-x-circle',
            time: 6000
          })
        } else {
          const array_errors = Object.entries(mensaje_error)
          for (let i = 0; i < array_errors.length; i++) {
            this.$vs.notify({
              title: 'Error',
              text: `${array_errors[i][1][0]}`,
              iconPack: 'feather',
              icon: 'icon-x-circle',
              color: 'warning',
              time: 6000
            })
          }
        }
      })

    //Carga de VideoTypeCalls
    // this.$store.dispatch('fetchVideoCallTypesAdmin')
    //   .catch(err => { 
    //     this.$vs.loading.close()
    //     // console.log(Object.getOwnPropertyNames(err))
    //     console.error(err)
    //     // console.log(err.response.data.errors)
    //     const mensaje_error = err.response.data.error
    //     if (typeof mensaje_error === 'string') {
    //       this.$vs.notify({
    //         title: 'Error',
    //         text: `${mensaje_error}`,
    //         color: 'warning',
    //         iconPack: 'feather',
    //         icon:'icon-x-circle',
    //         time: 6000
    //       })
    //     } else {
    //       const array_errors = Object.entries(mensaje_error)
    //       for (let i = 0; i < array_errors.length; i++) {
    //         this.$vs.notify({
    //           title: 'Error',
    //           text: `${array_errors[i][1][0]}`,
    //           iconPack: 'feather',
    //           icon: 'icon-x-circle',
    //           color: 'warning',
    //           time: 6000
    //         })
    //       }
    //     }
    //   })

  },
  mounted () {
    this.isMounted = true
  }
}

</script>

<style lang="scss">
.scroll-area {
  position: relative;
  margin: auto;
  width: auto;
  height: 400px;
}
#avatar-col {
  width: 10rem;
}

.letraAvatar {
  font-size: 30px;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

#document-table {
  td {
    vertical-align: top;
    min-width: 0px!important;
    padding-bottom: .8rem;
    word-break: break-all;
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

</style>
